import { render, staticRenderFns } from "./About.vue?vue&type=template&id=5a0a31cf&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=5a0a31cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a31cf",
  null
  
)

export default component.exports